import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";

export function useIsHireProfessionalsEnabled() {
  return useCbhFlag(CbhFeatureFlag.HIRE_PROFESSIONALS_ENABLED, {
    defaultValue: false,
  });
}
